// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"221":"stores","552":"visual-review"}[chunkId] + "." + {"221":"dfdc919d","552":"976a5495"}[chunkId] + ".css";
};